import { createContext, ReactNode, useState } from 'react'
import { Driver } from '../../store/drivers/drivers.type'
import { driverMock } from '../../store/drivers/drivers.fixtures'

export interface DriverProviderValue {
  driver: Driver
  setDriver: (driver: Driver) => void
}

interface DriverProviderProps {
  children: ReactNode
  value: DriverProviderValue
}

export const DriverContext = createContext<DriverProviderValue>({
  driver: driverMock,
  setDriver: () => null,
})

const DriverProvider = ({ children }: DriverProviderProps) => {
  const [selectedDriver, setSelectedDriver] = useState<Driver>(driverMock)

  return (
    <DriverContext.Provider
      value={{ driver: selectedDriver, setDriver: setSelectedDriver }}
    >
      {children}
    </DriverContext.Provider>
  )
}

export default DriverProvider
